import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../components/ui/dialog";
import { Phone, MapPin, Check, X } from "lucide-react";
import { BUSINESS } from "../data/site";

export default function ProductDetailModal({ product, onClose }) {
    const open = Boolean(product);
    return (
        <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
            <DialogContent className="max-w-3xl p-0 overflow-hidden gap-0 [&>button]:hidden" data-testid="product-modal">
                {product && (
                    <div className="grid md:grid-cols-2">
                        <div className="bg-slate-50 aspect-square md:aspect-auto">
                            <img src={product.image} alt={product.name} className="w-full h-full object-cover" />
                        </div>
                        <div className="p-7 flex flex-col">
                            <button onClick={onClose} data-testid="product-modal-close" className="self-end h-9 w-9 grid place-items-center rounded-full hover:bg-slate-100 -mr-2 -mt-2">
                                <X className="w-4 h-4" />
                            </button>
                            {product.brand && (
                                <div className="text-[10px] uppercase tracking-[0.22em] text-blue-600 font-semibold">{product.brand}</div>
                            )}
                            <DialogTitle className="mt-2 font-display font-bold text-slate-900 text-2xl tracking-tight">{product.name}</DialogTitle>
                            <div className="mt-2 text-2xl font-display font-bold text-slate-900">${product.price?.toFixed(2)}</div>
                            <DialogDescription className="mt-4 text-slate-600 leading-relaxed">
                                {product.description}
                            </DialogDescription>
                            {product.tags?.length > 0 && (
                                <ul className="mt-5 grid grid-cols-2 gap-2">
                                    {product.tags.map((t) => (
                                        <li key={t} className="flex items-center gap-2 text-sm text-slate-700">
                                            <Check className="w-4 h-4 text-emerald-500" /> {t}
                                        </li>
                                    ))}
                                </ul>
                            )}
                            <div className="mt-7 rounded-2xl border border-blue-100 bg-blue-50/60 p-4 text-sm">
                                <div className="font-semibold text-slate-900">Check stock in-store</div>
                                <div className="text-slate-600 mt-1">Call us to confirm availability or stop by today.</div>
                            </div>
                            <div className="mt-auto pt-6 flex gap-3">
                                <a href={`tel:${BUSINESS.phoneRaw}`} data-testid="modal-call-btn" className="flex-1 inline-flex items-center justify-center gap-2 h-11 rounded-full bg-slate-900 text-white font-semibold hover:bg-slate-800 transition">
                                    <Phone className="w-4 h-4" /> Call to Reserve
                                </a>
                                <a href={BUSINESS.mapsDirections} target="_blank" rel="noreferrer" data-testid="modal-directions-btn" className="flex-1 inline-flex items-center justify-center gap-2 h-11 rounded-full bg-blue-50 text-blue-700 font-semibold hover:bg-blue-100 transition">
                                    <MapPin className="w-4 h-4" /> Directions
                                </a>
                            </div>
                        </div>
                    </div>
                )}
            </DialogContent>
        </Dialog>
    );
}
